import { message as antdMessage } from "antd";

let messageApi = antdMessage;

export const setAntdMessageApi = (api) => {
  messageApi = api || antdMessage;
};

export const message = {
  open: (config) => messageApi.open(config),
  success: (content, duration, onClose) => messageApi.success(content, duration, onClose),
  error: (content, duration, onClose) => messageApi.error(content, duration, onClose),
  info: (content, duration, onClose) => messageApi.info(content, duration, onClose),
  warning: (content, duration, onClose) => messageApi.warning(content, duration, onClose),
  loading: (content, duration, onClose) => messageApi.loading(content, duration, onClose),
  destroy: (key) => messageApi.destroy(key),
  config: (options) => messageApi.config(options),
};
